import React, { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * - RegionSelect
 * - index 3 is india , rest everything is USD
 * @param {number}     selectedIndex   – currently selected option's index
 * @param {Function}   setSelectedIndex – parent’s state-setter
 */
 function PaymentRegionSelect({ selectedIndex, setSelectedIndex }) {
   const regions = [
    'USA',
    'China',
    'Europe',
    'India',
    'Rest of World (150+ countries)',
  ];
    // Keep the index valid if the regions array changes length.
  useEffect(() => {
    if (selectedIndex >= regions.length || selectedIndex<0)
         setSelectedIndex(0);
  }, []);

  return (
    <div className="relative inline-block w-full max-w-xs">
      <select
        value={selectedIndex}
        onChange={e => setSelectedIndex(Number(e.target.value))}
        className=
       /* small select
        "block w-full appearance-none
        rounded-md border border-gray-300
        bg-white text-sm       // smaller font 
        h-8 leading-4           // tighter height 
        pl-2 pr-6 py-1          // slim horizontal + vertical padding 
        focus:border-teal-500 focus:outline-none" */

        "block w-full appearance-none rounded-lg border border-gray-300 bg-white py-2 pl-3 pr-8 leading-tight text-gray-700 focus:border-indigo-500 focus:outline-none"
      >

        {regions.map((label, idx) => (
          <option key={idx} value={idx}>
            {label}
          </option>
        ))}
      </select>

      {/* Chevron overlay */}
      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <ChevronDown className="h-4 w-4" />
      </span>
    </div>
  );
}

/**
 * CurrencyToggle
 * A segmented control for choosing currencies (USD $, GBP £, EUR €, AUD $, INR ₹).
 *
 * Props:
 * - selectedIndex: number           // currently selected option
 * - setSelectedIndex: (n:number)=>void
 * - options?: { code:string, symbol:string, label?:string }[]  // optional override
 * - className?: string
 *
 * Accessibility:
 * - role="radiogroup", role="radio", arrow-key navigation, proper tabIndex/focus-ring.
 */
function CurrencyToggle({
  selectedIndex,
  setSelectedIndex,
  options = DEFAULT_OPTIONS,
  className = "",
}) {
  // keep index in range if options change
  useEffect(() => {
   /* if (selectedIndex < 0 || selectedIndex >= options.length) {
      setSelectedIndex(0);
    } */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.length]);

  const onKeyDown = (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex((selectedIndex + 1) % options.length);
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((selectedIndex - 1 + options.length) % options.length);
    }
  };

  return (
    <div className={`max-w-full overflow-x-auto px-2 ${className}`}>
      <div
        className="
          inline-flex items-center gap-1 rounded-full
          border border-blue-100 bg-white/95 p-1.5 text-sm
          shadow-sm ring-1 ring-blue-50 backdrop-blur
        "
        role="radiogroup"
        aria-label="Select currency"
        onKeyDown={onKeyDown}
      >
        {options.map((opt, idx) => {
          const selected = opt.id === selectedIndex;
          // visual label e.g. "USD $" or custom `label`
          const display = opt.label ?? `${opt.code} ${opt.symbol}`;
          return (
            <button
              key={opt.id} //  `${opt.code}-${idx}`
              type="button"
              role="radio"
              aria-checked={selected}
              tabIndex={selected ? 0 : -1}
              className={[
                "whitespace-nowrap rounded-full px-5 py-2 text-sm font-semibold transition-all duration-200 sm:px-7",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                selected
                  ? "bg-blue-600 text-white shadow-md shadow-blue-600/20 ring-1 ring-blue-500"
                  : "text-slate-600 hover:bg-blue-50 hover:text-blue-700 active:bg-blue-100",
              ].join(" ")}
              onClick={() => setSelectedIndex(opt.id)}
            >
              {display}
            </button>
          );
        })}
      </div>
    </div>
  );
}

/**
 * CurrencyToggle
 * A segmented control for choosing currencies (USD $, GBP £, EUR €, AUD $, INR ₹).
 *
 * Props:
 * - selectedIndex: number           // currently selected option
 * - setSelectedIndex: (n:number)=>void
 * - options?: { code:string, symbol:string, label?:string }[]  // optional override
 * - className?: string
 *
 * Accessibility:
 * - role="radiogroup", role="radio", arrow-key navigation, proper tabIndex/focus-ring.
 */
 function CurrencyToggleOld({
  selectedIndex,
  setSelectedIndex,
  options = DEFAULT_OPTIONS,
  className = "",
}) {
  // keep index in range if options change
  useEffect(() => {
   /* if (selectedIndex < 0 || selectedIndex >= options.length) {
      setSelectedIndex(0);
    } */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.length]);

  const onKeyDown = (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex((selectedIndex + 1) % options.length);
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((selectedIndex - 1 + options.length) % options.length);
    }
  };

  return (
    <div className={`max-w-full overflow-x-auto ${className}`}>
      <div
        className="inline-flex items-center gap-1 rounded-full 
        border border-gray-200 bg-gray-100 p-1 text-sm "
        role="radiogroup"
        aria-label="Select currency"
        onKeyDown={onKeyDown}
      >
        {options.map((opt, idx) => {
          const selected = opt.id === selectedIndex;
          // visual label e.g. "USD $" or custom `label`
          const display = opt.label ?? `${opt.code} ${opt.symbol}`;
          return (
            <button
              key={opt.id} //  `${opt.code}-${idx}`
              type="button"
              role="radio"
              aria-checked={selected}
              tabIndex={selected ? 0 : -1}
              className={[
                "whitespace-nowrap rounded-full px-6 py-1.5 transition-colors",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
                selected
                  ? "bg-white text-gray-900 shadow-sm ring-1 ring-black/5"
                  : "text-gray-700 hover:bg-gray-200/80 active:bg-gray-200",
              ].join(" ")}
              onClick={() => setSelectedIndex(opt.id)}
            >
              {display}
            </button>
          );
        })}
      </div>
    </div>
  );
}

const DEFAULT_OPTIONS = [
  { code: "USD", symbol: "$", id:0 },
  //{ code: "GBP", symbol: "£" },
  //{ code: "EURO", symbol: "€" },
  //{ code: "AUD", symbol: "$" },
  { code: "INR", symbol: "₹", id:3 },
];


export {PaymentRegionSelect, CurrencyToggle};